import { render, staticRenderFns } from "./PotentialWellViz.vue?vue&type=template&id=58ca9896&scoped=true"
import script from "./PotentialWellViz.vue?vue&type=script&lang=js"
export * from "./PotentialWellViz.vue?vue&type=script&lang=js"
import style0 from "./PotentialWellViz.vue?vue&type=style&index=0&id=58ca9896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca9896",
  null
  
)

export default component.exports